<template>
    <div class="blade">
        <slot name="divider"></slot>
        <slot name="searchAndOther"></slot>
        <slot name="body"></slot>
        <slot name="drawer"></slot>
        <slot name="dialog"></slot>
        <slot name="other"></slot>
    </div>
</template>

<script>
export default {
    name: 'Blade',
    data () {
        return {
            
        }
    }
}
</script>

<style scoped>
.blade {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.blade > .el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/blade/Blade.vue